module.exports = {
      id: "next-story-usage",
      viewBox: "0 0 40 40",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#next-story",
      toString: function () {
        return this.url;
      }
    }